import { queryParams } from '../utils/queryParams';

const queryToComponent = {
  computed: {
    queryParams: queryParams,
  },
}

export default queryToComponent
